import React from 'react';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';
import _ from 'lodash';
import ActionsBlock from './components/datatable/ActionsBlock';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'vat_return_reminder_id',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Vat Number',
    id: 'vat_number',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Year',
    id: 'year',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Period',
    id: 'quarter',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Reminded Date',
    id: 'reminded_date',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Sent?',
    id: 'is_sent',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>,
    inData: true,
  },
  // {
  //   label: 'Actions',
  //   align: 'center',
  //   id: 'action1',
  //   render: (
  //     rowIndex: number,
  //     cellValue: any,
  //     columnIndex: number,
  //     data: any
  //   ) => (
  //     <ActionsBlock
  //       rowIndex={rowIndex}
  //       error={data[rowIndex].error}
  //       message_text={data[rowIndex].message_text}
  //       vat_return_reminder_id={data[rowIndex].vat_return_reminder_id}
  //     />
  //   ),
  //   inData: false,
  // },
];

export const Translations = {
  page_title: {
    [Languages.Greek]: 'VAT Return Reminders',
    [Languages.English]: 'VAT Return Reminders',
  },
  table_title: {
    [Languages.Greek]: 'Generated VAT Return Reminders',
    [Languages.English]: 'Generated VAT Return Reminders',
  },
  generate_button: {
    [Languages.Greek]: 'Generate VAT Return Reminders',
    [Languages.English]: 'Generate VAT Return Reminders',
  },
  view_xml: {
    [Languages.Greek]: 'View',
    [Languages.English]: 'View',
  },
  view_error: {
    [Languages.Greek]: 'Error',
    [Languages.English]: 'Error',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  vat_number_search_control: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  year_search_control: {
    [Languages.Greek]: 'Year',
    [Languages.English]: 'Year',
  },
  period_search_control: {
    [Languages.Greek]: 'Period',
    [Languages.English]: 'Period',
  },
  reminded_date_from: {
    [Languages.Greek]: 'Reminded Date From',
    [Languages.English]: 'Reminded Date From',
  },
  reminded_date_to: {
    [Languages.Greek]: 'Reminded Date To',
    [Languages.English]: 'Reminded Date To',
  },
};
